import React, { useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import ActionCreator from "../../../store/actions/index";
import { Marker, Tooltip } from "react-leaflet";
import Leaflet from "leaflet";
import icon from "../../../images/mapPins/fuelPin.png";
import { typeRefuel } from "../../../utils/staticData";
import { getRoutesOfType } from '../../../utils/helpers';
import t from "../../../languages/pl";
import moment from "moment-timezone";
import { displayDateTimeFormat } from './../../../utils/staticData';

const refuelIcon = new Leaflet.icon({
    iconUrl: icon,
    iconSize: [50, 50],
    iconAnchor: [25, 50]
});

const drawMarkers = (elements) => {
    if (!Array.isArray(elements))
        elements = [elements];
    return elements.map(marker => {
        return (
            <Marker
                key={marker.id}
                icon={refuelIcon}
                position={[marker.lat, marker.lon]}
                zIndexOffset={800}
            >
                <Tooltip
                    direction="top"
                    className="toyotaFont"
                    offset={new Leaflet.point(0, -50)}
                >
                    {t.date}: {moment.unix(marker.data).format(displayDateTimeFormat)}
                    <br />
                    {t.refuel}: {marker.litry}&nbsp;l
                </Tooltip>
            </Marker>
        );
    });
};

const RefuelMarker = props => {
    const { selectedRoutes, refuelFilter } = props;
    const [visibleMarkers, setMarkers] = useState([]);

    useEffect(() => {
        if(!selectedRoutes || !Array.isArray(selectedRoutes) || selectedRoutes.length === 0)
            return setMarkers([]);
        let selectedRefuel = getRoutesOfType(selectedRoutes, typeRefuel);
        selectedRefuel = selectedRefuel.filter(refuel => refuel.selected === true);
        setMarkers(selectedRefuel);
    }, [selectedRoutes, refuelFilter]);

    return (
        <Fragment>
            {drawMarkers(visibleMarkers)}
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        selectedRoutes: state.mapRoutesReducer.selectedRoutes,
        refuelFilter: state.filterReducer.refuel,
        routes: state.mapRoutesReducer.routes,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RefuelMarker);

RefuelMarker.propTypes = {
    selectedRoutes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    refuelFilter: PropTypes.bool,
    fitInBounds: PropTypes.func.isRequired,
};